module.exports = __webpack_public_path__ + "img/LogoSm.4ff24b6d.png";